
import { action } from 'typesafe-actions'

export interface IUser  {
    id: string
    userId: string
    userStatus: string
    userStatusDetails: string
    personId: string
    gender: string
    fullName: string
    icNo: string
    icFileName: string
    contactNo: string
    emailAdd: string
    permanentAdd: string
    mailingAdd: string
    compName: string
    compReg: string
    compPosition: string
    compContactNo: string
    compAdd: string
    compSalaryRange: string
    country: string
    professionList: PC[]
    createdDT: string
    createdBy: string
    lastEdited: string
    lastEditedBy: string
    logged: boolean
    verified: boolean
    version : number
    updateState?: number  // 0: Initial, 1: Success, 2: Failed
    error?: string
    _etag?: string // to detect if new changes
}

// export interface IUser  {
//     id:string
//     name:string
//     logged: boolean
//     verified: boolean
//     personId:string
//     membershipCode:string
//     membershipCategory:string
//     fullName:string
//     NIRC:string
//     PersonalContactNumber:string
//     PersonalEmailAddress:string
//     PersonalAddress:string
//     CompanyName:string
//     Position:string
//     CompanyContactNumber:string
//     CompanyAddress:string
//     SalaryRange:string
//     ProfessionalCategory:PC[]
//     RegulationBody:string
//     InstitutionAssociationBodyNumber:string
// }

 export interface PC {
    [key: string]: any;
 }
export const USER = {
    login: {
        success: 'USER_LOGIN_SUCCESS',
    },
    logout: {
        success: 'USER_LOGOUT_SUCCESS',
    },
    verify: {
        success: 'USER_VERIFY_SUCCESS',
        error: 'USER_VERIFY_ERROR',
        request: 'USER_VERIFY_REQUEST',
    },
    Profile:{
        
        success: 'USER_PROFILE_SUCCESS',
        error: 'USER_PROFILE_ERROR',
        request: 'USER_PROFILE_REQUEST',
        update: 'USER_PROFILE_UPDATE',
        add: 'USER_PROFILE_ADD'
    }
};
const userToken = 'user'; 
    
export const login = () => {
    localStorage.setItem(userToken, "true");
    return action( USER.login.success);
}
export const logout = () => {
    localStorage.removeItem(userToken);
    return action(USER.logout.success);
}
export const verify = (account:any) => {
    return action( USER.verify.request,account);
}
export const verified = () =>{
    const user = localStorage.getItem(userToken);
    if (user) {
        return action( USER.verify.success);
    }
    return action(USER.verify.error);
}

export const UpdateUserProfile = (account:any) => {
    return action( USER.Profile.update, account);
}

export const fetchUserRequest = () => {
    //console.log("fetchRequest: " + searchParams.searchTerm);
    return action(USER.Profile.request);
 }
